<template>
  <a
    class="help-center-mobile-menu-item__link"
    :href="menuItem.url"
    :class="className"
    @click="onClick"
  >
    <i
      v-if="menuItem.fa_icon"
      :class="menuItem.fa_icon"
      :style="menuItem.fa_style"
      class="help-center-mobile-menu-item__icon"
    />
    <span>
      {{ menuItem.title }}
    </span>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import isLeftClick from 'gleam-shared/browser/isLeftClick'

const emit = defineEmits(['navigate'])
const props = defineProps({
  menuItem: {
    type: Object,
    required: true
  },
  selectedTab: {
    type: Object,
    required: true
  }
})

const className = computed(() => {
  if (props.menuItem.url === props.selectedTab.url) {
    return 'help-center-mobile-menu-item__link--selected'
  } else {
    return null
  }
})

function onClick(event) {
  if (isLeftClick(event)) {
    emit('navigate')
  }
}
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-mobile-menu-item {
  &__link {
    @include help-center-font(16);
    @include help-center-accent-link;

    gap: 8px;
    display: flex;

    &--selected {
      font-weight: var(--help-center-bold);
    }
  }

  &__icon {
    @include help-center-icon(24);
    flex: none;
  }
}
</style>
